import React from 'react'
import { connect } from 'react-redux'
import Toggle from 'react-toggle'
import PresetActions from '../../Redux/PresetRedux'

class ShippingPreset extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      toggle: {
        ID: {
          'airport': false,
          'by-myself': false,
          'courier': false
        }
      }
    }
  }

  componentDidMount = () => {
    this.props.get()
  }

  componentDidUpdate = (prevProps) => {
    const { dataShipping } = this.props.preset
    if (prevProps !== this.props) {
      if (dataShipping.ID) {
        this._populateToggle(dataShipping.ID, 'ID')
      }
    }
  }

  _populateToggle = (args, country) => {
    this.setState({
      toggle: {
        [country]: {
          'airport': args['airport'],
          'by-myself': args['by-myself'],
          'courier': args['courier']
        }
      }
    })
  }

  _disableToggle = (args, method) => {
    switch (method) {
      case 'airport':
        return !args['by-myself'] && !args['courier']
      case 'by-myself':
        return !args['airport'] && !args['courier']
      case 'courier':
        return !args['airport'] && !args['by-myself']
      default:
        return false
    }
  }

  _renderCard = (preset, country, title) => {
    return (
      <section className='section' style={{ width: '50%' }}>
        <div className='card'>
          <div className='card-block'>
            <div className='title-block'>
              <h3 className='title'>{title}</h3>
            </div>
            <table className='table table-hover table-striped'>
              <thead>
                <tr>
                  <th className='text-center'>Shipping Method</th>
                  <th className='text-center'>Active</th>
                </tr>
              </thead>
              <tbody>
                { this._renderToggle(preset, country, 'airport', 'Airport') }
                { this._renderToggle(preset, country, 'by-myself', 'Self Pickup') }
                { this._renderToggle(preset, country, 'courier', 'Courier') }
              </tbody>
            </table>
          </div>
        </div>
      </section>
    )
  }

  _renderToggle = (preset, country, method, title) => {
    let { toggle } = this.state
    return (
      <tr>
        <td className='text-center'>{title}</td>
        <td className='text-center'>
          <Toggle
            disabled={this._disableToggle(toggle[country], method)}
            checked={toggle[country][method]}
            onChange={() => this._handleToggle(method, country, preset.dataShipping[country][method])}
          />
        </td>
      </tr>
    )
  }

  _handleToggle = (keys, country, currentValue) => {
    let value = !currentValue
    let data = { keys, country, value }
    this.props.post(data)
  }

  render () {
    const { preset } = this.props
    return (
      <section className='section'>
        <header>
          <div className='title-block'>
            <h1 className='title'>
              Shipping Preset
              { preset.fetchingShipping && <div className='ml-2 badge badge-info'>Loading ...</div> }
            </h1>
          </div>
        </header>
        { this._renderCard(preset, 'ID', 'Indonesia') }
      </section>
    )
  }
}

const stateToProps = (state) => ({
  preset: state.preset
})

const dispatchToProps = (dispatch) => ({
  get: () => dispatch(PresetActions.getShipping()),
  post: (data) => dispatch(PresetActions.updateShipping(data))
})

export default connect(stateToProps, dispatchToProps)(ShippingPreset)



// WEBPACK FOOTER //
// ./src/Pages/Misc/ShippingPreset.js